import { render, staticRenderFns } from "./CompanyProfileGate.vue?vue&type=template&id=0f64d90d"
import script from "./CompanyProfileGate.vue?vue&type=script&lang=js"
export * from "./CompanyProfileGate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports